import { consolidatedPortfolioSelectorConfig } from './consolidatedPortfolio'
import { globalPositionSelectorConfig } from './globalPosition'

export const selectorsConfig = {
  ...consolidatedPortfolioSelectorConfig,
  ...globalPositionSelectorConfig,
}
